import TextareaAutosize from '@mui/base/TextareaAutosize'
import AddIcon from '@mui/icons-material/Add'

import FilterListIcon from '@mui/icons-material/FilterList'
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded'
import ModelTrainingIcon from '@mui/icons-material/ModelTraining'
import PsychologyIcon from '@mui/icons-material/Psychology'
import SearchIcon from '@mui/icons-material/Search'
import LoadingButton from '@mui/lab/LoadingButton'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import {Checkbox, Divider, IconButton, ListItem, ListItemText, TextField} from '@mui/material'
import Badge from '@mui/material/Badge'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import {deepPurple, grey} from '@mui/material/colors'
import ConceptsAutoCompleteNotify from 'app/components/concepts/ConceptsAutoCompleteNotify'
import DragableConceptsListNotifications from 'app/components/concepts/DraggableConceptListNotifications'
import KeywordListNotify from 'app/components/keywords/keywordListNotify'
import {useAuthProvider} from 'app/modules/auth'
import {IConceptFE} from 'interfaces/IConceptFE'
import {ISavedSearchFE} from 'interfaces/ISavedSearchFE'
import React, {useEffect, useState} from 'react'
import Skeleton from 'react-loading-skeleton'
import {useDispatch, useSelector} from 'react-redux'
import {
  classifyTextOnly,
  saveNewNotifySearch,
  updateSavedNotificationSearch,
} from 'redux/actions/savedSearchActions'
import {selectSavedSearchSlice} from 'redux/selectors/savedSearchSelector'
import {AppDispatch} from 'redux/store'
import styled from 'styled-components'
import {useTextAreaStyle} from 'styles/useStyles'
import {emGetActiveTenantData, emHasFeature} from 'utilities/emUserFeatures'

const DiscoveryContent = styled.div`
  height: 100%; /* TODO: Mobile view */
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 400px;
`

const DiscoveryRightActions = styled.div`
  text-align: right;
  display: flex;
  justify-content: flex-end;
`

export default function DiscoveryDescribeRequirementsNotifySearch({
  savedSearch,
  setSavedSearch,
  showAddSearchDialog,
  handleCloseDialog,
}: {
  savedSearch?: ISavedSearchFE
  setSavedSearch: React.Dispatch<React.SetStateAction<ISavedSearchFE | undefined>>
  showAddSearchDialog: boolean
  handleCloseDialog: () => void
}): React.ReactElement {
  const {reduxUser} = useAuthProvider()
  const [saving, setSaving] = useState<boolean>(false)
  const dispatch = useDispatch<AppDispatch>()
  const taStyle = useTextAreaStyle()
  const [parentValue, setParentValue] = React.useState<IConceptFE | string | undefined>(undefined)
  const [showAutoComplete, setShowAutoComplete] = React.useState<boolean>(false)
  const [analyzed, setAnalyzed] = React.useState<boolean>(false)
  const [conceptKeywordTab, setConceptKeywordTab] = React.useState('1')
  const [searchText, setSearchText] = useState<string>('')
  const savedSearchRedux = useSelector(selectSavedSearchSlice)
  const [isLoadingClassify, setIsLoadingClassify] = useState<boolean>(false)
  //const [showAddSearchDialog, setShowAddSearchDialog] = React.useState<boolean>(false)

  // const [savedSearch, setSavedSearch] = React.useState<ISavedSearchFE | undefined>(
  //   savedNotifySearch ? savedNotifySearch : ({search_text: searchText ?? null} as ISavedSearchFE)
  // )

  const [editingName, setEditingName] = useState(false)

  useEffect(() => {
    if (savedSearch) {
      setSearchText(savedSearch?.search_text ?? '')
      setSearchName(savedSearch?.name ?? '')
    } else {
      //it is a new search
      setSearchText('')
      setSearchName('')
      setEditingName(false)
      setAnalyzed(false)
    }
  }, [savedSearch])

  const handleChangeConceptKeywordTab = (event: React.SyntheticEvent, newValue: string) => {
    setConceptKeywordTab(newValue)
  }

  // async function submit(inSearch: ISavedSearchFE, isUpdate: boolean, maxResults?: number) {
  //   const search = {...inSearch}
  //   if (searchName) {
  //     search.name = searchName
  //   }
  //   if (checked && checked.length > 0) {
  //     search.notify_entities = checked
  //   } else {
  //     search.notify_entities = [] //default to opportunities if nothing is selected
  //   }

  //   //TODO : need to check if notify for the search is passed in props and save search acccordigly
  //   if (search) {
  //     setIsLoadingClassify(true)
  //     await dispatch(
  //       classifyTextWNotifySearch({
  //         search_text: searchText,
  //         isUpdate: isUpdate ? isUpdate : search.id ? true : false,
  //         originalSavedSearch: search,
  //         per_page: maxResults,
  //         pages: 1,
  //       })
  //     )
  //     setIsLoadingClassify(false)
  //   }
  // }

  //An analysis builds off a search
  async function submitAnalysis(inSearch: ISavedSearchFE, maxResults?: number) {
    const search = {...inSearch}
    if (searchName) {
      search.name = searchName
    }
    if (checked && checked.length > 0) {
      search.notify_entities = checked
    } else {
      search.notify_entities = [] //default to opportunities if nothing is selected
    }
    if (search) {
      setIsLoadingClassify(true)
      const resp = await dispatch(
        classifyTextOnly({
          search_text: searchText,
          originalSavedSearch: search,
          per_page: maxResults ?? 1,
          pages: 1,
        })
      )
      if (resp.payload) {
        const cast = resp.payload as ISavedSearchFE
        setSavedSearch(cast)
      }

      setIsLoadingClassify(false)
      setAnalyzed(true)
    }
  }

  // already analyzed, so we can reanalyze
  async function onReAnalyze() {
    if (!savedSearch) {
      console.warn('No search to reanalyze')
      return
    }
    if (!searchText) {
      return
    }

    submitAnalysis(savedSearch, 10)
  }

  // initial Analyze
  async function onAnalyze() {
    if (!searchText) {
      return
    }
    savedSearch && submitAnalysis(savedSearch, 10)
  }

  async function save() {
    setSaving(true)
    if (!savedSearch || !searchText) {
      return
    }
    if (!checked || checked.length === 0) {
      alert('Please select at least one entity type to receive notifications about.')
      return
    }

    const search = {...savedSearch, search_text: searchText}
    if (searchName) {
      search.name = searchName
    }
    if (checked && checked.length > 0) {
      search.notify_entities = checked
    } else {
      search.notify_entities = [] //default to opportunities if nothing is selected
    }

    if (savedSearch?.id) {
      const res = await dispatch(
        updateSavedNotificationSearch({
          id: savedSearch.id,
          search: search,
          originalSavedSearch: savedSearch,
        })
      )
      if (res.payload) {
        const cast = res.payload as ISavedSearchFE
        setSavedSearch(cast)
      }
      setSaving(false)
      handleCloseDialog()
    } else {
      //no search id so it's a new search
      const res = await dispatch(saveNewNotifySearch({search: search}))
      if (res.payload) {
        const cast = res.payload as ISavedSearchFE
        setSavedSearch(cast)
      }
      setSaving(false)
      //allow saving the search without closing the dialog
      //handleCloseDialog()
    }
  }

  const onConfirmAddingConcept = async () => {
    if (!savedSearch || !parentValue || !savedSearch.id) {
      return
    }

    if (typeof parentValue === 'string') {
      if (!savedSearch?.keywords?.includes(parentValue)) {
        const s = {...savedSearch}
        s.keywords = [parentValue, ...(savedSearch?.keywords ?? [])]
        const res = await dispatch(
          updateSavedNotificationSearch({
            id: savedSearch.id,
            search: s,
            originalSavedSearch: savedSearch,
          })
        )
        if (res.payload) {
          const cast = res.payload as ISavedSearchFE
          setSavedSearch(cast)
        }
      }
    } else {
      const concept = parentValue
      concept.__weight = 1
      concept.__lock = 'include'
      const s = {...savedSearch}
      s.concepts = [concept, ...(savedSearch?.concepts ?? [])]
      const res = await dispatch(
        updateSavedNotificationSearch({
          id: savedSearch.id,
          search: s,
          originalSavedSearch: savedSearch,
        })
      )
      if (res.payload) {
        const cast = res.payload as ISavedSearchFE
        setSavedSearch(cast)
      }
    }
  }

  //this i for Load Mor button to add more concepts to the search
  const onAnalyzeMore = async () => {
    if (!savedSearch) {
      return
    }

    submitAnalysis(savedSearch, (savedSearch?.concepts?.length ?? 10) + 10)
  }

  const conceptCount = React.useMemo(() => {
    return savedSearch?.concepts?.filter((i) => i.__lock !== 'exclude')?.length ?? '0'
  }, [savedSearch])

  const keywordsCount = React.useMemo(() => {
    return savedSearch?.keywords?.length ?? '0'
  }, [savedSearch])

  const [searchName, setSearchName] = React.useState<string>(savedSearch?.name ?? '')

  const [checked, setChecked] = React.useState<string[]>(savedSearch?.notify_entities ?? [])

  const handleToggle = (value: string) => () => {
    const currentIndex = checked?.indexOf(value)
    const newChecked = checked ? [...checked] : []
    const subscriptionAlert = !emHasFeature(
      'classify-search',
      emGetActiveTenantData(reduxUser ?? {})?.id ?? '',
      reduxUser?.features ?? {}
    )
    //for use once we allow other entities to be searched
    // if (subscriptionAlert && value !== 'opportunities') {
    //   alert(
    //     'A paid subscription is required to run notification searches for all entities except opportunities. Upgrade to a paid subscription to run notification searches for all entities.'
    //   )
    //   return
    // }
    if (value !== 'opportunities') {
      alert(
        'Only opportunties are supported for notification searches at this time. Please select opportunities to receive notifications.'
      )
      return
    }

    if (currentIndex && currentIndex === -1) {
      newChecked.push(value)
    } else {
      currentIndex && newChecked.splice(currentIndex, 1)
    }

    setChecked(newChecked)
  }

  return (
    <Box>
      {saving ? (
        <Box display={'flex'} justifyContent={'center'} textAlign={'center'} alignItems={'center'}>
          <Box
            display={'flex'}
            flexDirection={'row'}
            alignContent={'center'}
            textAlign={'center'}
            alignItems={'center'}
            gap={2}
          >
            <Typography variant={'h4'} color={grey[600]} mt={1}>
              Saving...
            </Typography>

            <CircularProgress size={35} />
          </Box>
        </Box>
      ) : (
        <Box mt={2}>
          <Grid container>
            <Grid item xs={12}>
              <Box display={'flex'} justifyContent={'space-between'}>
                <Typography variant={'h6'}>
                  Run Notification Search for the following entities:
                </Typography>
                {/* <Button
                    variant={'contained'}
                    color={'primary'}
                    onClick={save}
                    disabled={!searchText || !savedSearch || isLoadingClassify}
                  >
                    Save Changes
                  </Button> */}
              </Box>
              <Box display={'flex'}>
                {['opportunities', 'businesses', 'awards', 'people', 'innovations'].map((value) => {
                  const labelId = `checkbox-list-label-${value}`
                  return (
                    <ListItem key={value} role={undefined} dense onClick={handleToggle(value)}>
                      <Checkbox
                        edge='start'
                        checked={checked?.includes(value)}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{'aria-labelledby': labelId}}
                      />

                      <ListItemText id={labelId} primary={`${value}`} />
                    </ListItem>
                  )
                })}
              </Box>
            </Grid>

            <Grid item xs={12}>
              {!analyzed || editingName ? (
                <Box>
                  <TextField
                    defaultValue={searchName}
                    placeholder={'Add a name for your search'}
                    onChange={(e) => setSearchName(e.currentTarget.value)}
                    sx={{width: '25em', mb: 1}}
                    size={'small'}
                    variant={'filled'}
                  />
                  {editingName && Boolean(searchName) && (
                    <Button
                      size={'small'}
                      variant={'outlined'}
                      onClick={() => savedSearch && save()}
                    >
                      Save
                    </Button>
                  )}
                </Box>
              ) : (
                <Box display={'flex'}>
                  <Typography variant={'h6'} mr={1} fontWeight={700}>
                    Search Name:
                  </Typography>
                  <Badge
                    badgeContent={
                      <IconButton onClick={() => setEditingName(true)} color={'primary'}>
                        <ModeEditRoundedIcon />
                      </IconButton>
                    }
                    sx={{'& span': {transform: 'translate(90%, -40%)', zIndex: 0}}}
                  >
                    <Typography variant={'h6'} color={grey[700]}>
                      {searchName}
                    </Typography>
                  </Badge>
                </Box>
              )}
            </Grid>
            <Grid item xs={8}>
              <DiscoveryContent>
                <TextareaAutosize
                  className={taStyle.textArea}
                  aria-label='minimum height'
                  minRows={20}
                  placeholder='Enter a search query ... e.g. "the purpose of this topic is to utilize Artificial Intelligence and Machine Learning (AI/ML) in conjuction...'
                  value={searchText}
                  nonce={undefined}
                  onResize={undefined}
                  onResizeCapture={undefined}
                  onChange={(e: any) => {
                    setSearchText(e.target.value)
                  }}
                  style={{fontSize: '1.2rem'}}
                />

                {/* Separator */}

                <DiscoveryRightActions>
                  {analyzed ? (
                    <>
                      <Button
                        color={'success'}
                        variant={'contained'}
                        disabled={!searchText}
                        onClick={onReAnalyze}
                        size={'small'}
                      >
                        {'Re-Analyze Text'}
                      </Button>
                    </>
                  ) : (
                    <Box mt={1}>
                      <Button
                        size={'small'}
                        color={'success'}
                        variant={'contained'}
                        disabled={!searchText || savedSearchRedux.status === 'loading'}
                        onClick={onAnalyze}
                      >
                        {!isLoadingClassify && !analyzed ? (
                          <Box component={'span'} display={'flex'} gap={1}>
                            <SearchIcon />
                            Analyze Text for Concepts
                          </Box>
                        ) : (
                          <Box component={'span'} display={'flex'} gap={1}>
                            Analyzing... <CircularProgress size={'medium'} />
                          </Box>
                        )}
                      </Button>
                    </Box>
                  )}
                </DiscoveryRightActions>
              </DiscoveryContent>
            </Grid>

            <Grid item xs={4}>
              {isLoadingClassify ? (
                <div style={{width: '100%'}}>
                  <Skeleton
                    height={42}
                    count={5}
                    wrapper={({children}) => {
                      return <div style={{marginTop: '5px'}}>{children}</div>
                    }}
                  />
                </div>
              ) : (
                <>
                  {savedSearch?.concepts && savedSearch.concepts.length ? (
                    <TabContext value={conceptKeywordTab}>
                      <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList
                          onChange={handleChangeConceptKeywordTab}
                          aria-label='lab API tabs example'
                        >
                          <Tab
                            icon={
                              <Badge
                                badgeContent={conceptCount}
                                sx={{
                                  '& .MuiBadge-badge': {
                                    color: grey[700],
                                    background: deepPurple[50],
                                  },
                                }}
                                showZero={false}
                              >
                                <PsychologyIcon fontSize={'large'} />{' '}
                              </Badge>
                            }
                            label={'Related Concepts'}
                            value='1'
                          />
                          <Tab
                            icon={
                              <Badge
                                badgeContent={keywordsCount}
                                showZero={false}
                                sx={{
                                  '& .MuiBadge-badge': {
                                    color: grey[700],
                                    background: deepPurple[50],
                                  },
                                }}
                              >
                                <FilterListIcon />{' '}
                              </Badge>
                            }
                            label='Keyword Filters'
                            value='2'
                          />
                        </TabList>
                      </Box>
                      <TabPanel value='1'>
                        {showAutoComplete ? (
                          <ConceptsAutoCompleteNotify
                            search={savedSearch}
                            parentOwned={true}
                            placeholder={'Add new concept or keyword filter'}
                            setParentValue={setParentValue}
                            onConfirm={onConfirmAddingConcept}
                            onCancel={setShowAutoComplete}
                          />
                        ) : (
                          <Button
                            onClick={() => setShowAutoComplete(true)}
                            variant={'text'}
                            size={'large'}
                            sx={{p: 1, mb: 2.5}}
                          >
                            <AddIcon />
                            Add A Concept or Keyword Filter
                          </Button>
                        )}

                        <DragableConceptsListNotifications
                          search={savedSearch}
                          stackVertical={true}
                          chipSize={'lg'}
                          disabledText={
                            savedSearch?.id
                              ? undefined
                              : 'Save your search in order to edit concepts or keywords.'
                          }
                        />
                        <LoadingButton
                          loading={isLoadingClassify}
                          loadingPosition='start'
                          startIcon={<ModelTrainingIcon sx={{fontSize: '1.5em !important'}} />}
                          variant={'contained'}
                          color={'success'}
                          fullWidth
                          onClick={onAnalyzeMore}
                          sx={{
                            p: 0.5,
                            m: 0.5,
                            mt: 1,
                            fontSize: '1em',
                            width: '-webkit-fill-available',
                          }}
                        >
                          Load More Concepts
                        </LoadingButton>
                      </TabPanel>
                      <TabPanel value='2'>
                        <KeywordListNotify search={savedSearch} />
                      </TabPanel>
                    </TabContext>
                  ) : (
                    <Box display={'flex'} flex={'1 1 auto'} m={1} flexDirection={'column'}>
                      {/* Muted paragraph to show that the user must describe requirements */}
                      <Typography variant={'h6'} color={grey[500]} mb={1}>
                        Click
                        {/* Small button */}
                        <Button onClick={onAnalyze} disabled={!searchText}>
                          Analyze
                        </Button>
                        to process your problem statement/search query. Identified concepts will
                        show below...
                      </Typography>
                      <Box>
                        <Typography variant='caption'>
                          <Stack direction={'column'} spacing={1} flexWrap={'wrap'}>
                            {[1, 2, 3, 4, 5].map((concept, idx) => {
                              return (
                                <Box display={'inline-flex'} key={idx}>
                                  <Chip
                                    component={'span'}
                                    label={
                                      <Box
                                        display={'flex'}
                                        gap={2}
                                        justifyContent={'space-between'}
                                        color={grey[500]}
                                      >
                                        <PsychologyIcon fontSize={'large'} color={'inherit'} />
                                        <Typography variant={'h6'} color={grey[300]}>
                                          -Example Concept identified from search query analysis
                                        </Typography>
                                      </Box>
                                    }
                                    sx={{
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                      flexDirection: 'row',
                                      height: 'auto',
                                      m: 0.5,
                                      fontSize: '.8rem',
                                      borderRadius: '2em',
                                      width: '100%',
                                      alignItems: 'flex-end',
                                      justifyContent: 'flex-start',
                                      boxShadow:
                                        'rgba(0, 0, 0, 0.3) 0px 1px 1px, rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.1) 0px 0px 0px inset',
                                      bgcolor: grey[50],
                                      '& .MuiChip-label': {
                                        fontSize: '1rem',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flexWrap: 'wrap',
                                        overflowWrap: 'break-word',
                                        whiteSpace: 'normal',
                                      },
                                    }}
                                  />
                                </Box>
                              )
                            })}
                          </Stack>
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </>
              )}
            </Grid>

            <Grid item xs={12}>
              <br />
              <Divider />
              <br />
              <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Button onClick={() => handleCloseDialog()}>Cancel</Button>
                <Button
                  variant={'contained'}
                  onClick={() => {
                    save()
                  }}
                  disabled={!searchText || !savedSearch || isLoadingClassify}
                  color='primary'
                >
                  {`${savedSearch?.id ? 'Save & Close' : 'Save New Search'}`}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  )
}
